export const colors = ['#1684EA', '#17B0E2', '#6544F9', '#868AA5'];
export const getPiChartConfig = (chartData, chartType) => {
  return {
    type: chartType,
    chartData,
    options: {
      cutout: chartType === 'doughnut' ? '80%' : '0%',
      responsive: true,
      layout: {
        padding: 0
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            usePointStyle: true,
            pointStyle: 'circle',
            boxWidth: 8,
            boxHeight: 8,
            font: {
              size: 12
            }
          }
        }
      },
      maintainAspectRatio: false
    }
  };
};
//# sourceMappingURL=helper.js.map